import { render, staticRenderFns } from "./UtilEventsUpcoming.vue?vue&type=template&id=e03017a4&scoped=true"
import script from "./UtilEventsUpcoming.vue?vue&type=script&lang=js"
export * from "./UtilEventsUpcoming.vue?vue&type=script&lang=js"
import style0 from "./UtilEventsUpcoming.vue?vue&type=style&index=0&id=e03017a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03017a4",
  null
  
)

export default component.exports